import { render, staticRenderFns } from "./DsfExamMarking.vue?vue&type=template&id=6f2ae404&"
import script from "./DsfExamMarking.vue?vue&type=script&lang=js&"
export * from "./DsfExamMarking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f2ae404')) {
      api.createRecord('6f2ae404', component.options)
    } else {
      api.reload('6f2ae404', component.options)
    }
    module.hot.accept("./DsfExamMarking.vue?vue&type=template&id=6f2ae404&", function () {
      api.rerender('6f2ae404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfExamMarking.vue"
export default component.exports